export const colors = {
  dark: "#333",
  white: "#fff",
  background: "#14141f",
  darkGrey: "#343444",
  buttonDisabled: "#8a8aa0",
  royalBlue: "#5142fc",
  black: "#000",

  pills: {
    normal: "#b8b8a8",
    fighting: "#f87070",
    flying: "#a890f0",
    poison: "#e090f8",
    ground: "#e0c068",
    rock: "#c8a048",
    bug: "#a0c888",
    ghost: "#a870f8",
    steel: "#b8b8d0",
    fire: "#f89030",
    water: "#6898f7",
    grass: "#90e880",
    electric: "#e0e000",
    psychic: "#f838a8",
    ice: "#30d8cf",
    dragon: "#7038f8",
    dark: "#3a3838",
    fairy: "#ff65d5",
    unknown: "linear-gradient(-225deg, #3D4E81 0%, #5753C9 48%, #6E7FF3 100%)",
    shadow: "#1e3c72 0%, #1e3c72 1%, #2a5298 100%)",
  },
  backgrounds: {
    normal: "linear-gradient(to top, #d299c2 0%, #fef9d7 100%)",
    fighting: "linear-gradient(to right, #fa709a 0%, #fee140 100%)",
    flying: "linear-gradient(to top, #5ee7df 0%, #b490ca 100%)",
    poison: "linear-gradient(to top, #96fbc4 0%, #f9f586 100%)",
    ground: "linear-gradient(to right, #c1c161 0%, #c1c161 0%, #d4d4b1 100%)",
    rock: "linear-gradient(to right, #868f96 0%, #596164 100%)",
    bug: "linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%)",
    ghost: "linear-gradient(120deg, #a6c0fe 0%, #f68084 100%)",
    steel: "linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%)",
    fire: "linear-gradient(to right, #f83600 0%, #f9d423 100%)",
    water: "linear-gradient(-20deg, #6e45e2 0%, #88d3ce 100%)",
    grass: "linear-gradient(to top, #0fd850 0%, #f9f047 100%)",
    electric: "linear-gradient(to right, #f9d423 0%, #ff4e50 100%)",
    psychic: "linear-gradient(-225deg, #A445B2 0%, #D41872 52%, #FF0066 100%)",
    ice: "linear-gradient(-225deg, #9EFBD3 0%, #57E9F2 48%, #45D4FB 100%)",
    dragon: "linear-gradient(-225deg, #473B7B 0%, #3584A7 51%, #30D2BE 100%)",
    dark: "linear-gradient(-20deg, #616161 0%, #9bc5c3 100%)",
    fairy: "linear-gradient(to top, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)",
    unknown: "linear-gradient(-225deg, #3D4E81 0%, #5753C9 48%, #6E7FF3 100%)",
    shadow: "#1e3c72 0%, #1e3c72 1%, #2a5298 100%)",
  },
};
